// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__33Q49","container":"styles_container__2fBx_","title":"styles_title__1Enko","wrapper":"styles_wrapper__2646u","answer":"styles_answer__2JR-C"};